
export const FETCH_STUDIO_APP_CONF_SUCCESS = 'FETCH_STUDIO_APP_CONF_SUCCESS';
export const FETCH_STUDIO_APP_CONF_HAS_ERRORED = 'FETCH_STUDIO_APP_CONF_HAS_ERRORED';
export const FETCH_STUDIO_APP_CONF_IS_LOADING = 'FETCH_STUDIO_APP_CONF_IS_LOADING';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.ts